import { Component,Inject } from '@angular/core';
import { MatDialogRef,MAT_DIALOG_DATA } from '@angular/material';
import { FourDService, ProcessorAPI } from '4d-mapper';


@Component({
    selector: 'api-dialog',
    templateUrl: './api-dialog.html',
})

export class APIDialog {

    curApi:ProcessorAPI

    constructor(public dialogRef: MatDialogRef<APIDialog>, @Inject(MAT_DIALOG_DATA) public data: any,private fourD:FourDService) {
        this.curApi = data.apis[0];

    }
    ok(bypassPreview? : boolean){
      this.dialogRef.close({api:this.curApi,model:this.data.model, datasetName: this.data.datasetName, bypassPreview: bypassPreview})
    }
    cancel() {
        this.dialogRef.close(false);
    }
    onClick(arg?:any){
        this.dialogRef.close(false)
      }
}


@Component({
    selector: 'empty-dialog',
    templateUrl: './empty-dialog.html',
})

export class EmptyDialog {


    constructor(public dialogRef: MatDialogRef<APIDialog>, @Inject(MAT_DIALOG_DATA) public data: any,private fourD:FourDService) {

    }

    onClick(){
      this.dialogRef.close(false)
    }
}

